document.addEventListener('DOMContentLoaded', function(event) {"use strict";

window._animate = function (draw) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 750;
  animate({
    duration: duration,
    timing: makeEaseInOut(quad),
    draw: draw
  });

  function animate(options) {
    var start = performance.now();
    requestAnimationFrame(function animate(time) {
      var timeFraction = (time - start) / options.duration;
      if (timeFraction > 1) timeFraction = 1;
      var progress = options.timing(timeFraction);
      options.draw(progress);

      if (timeFraction < 1) {
        requestAnimationFrame(animate);
      }
    });
  }

  function makeEaseInOut(timing) {
    return function (timeFraction) {
      if (timeFraction < .5) {
        return timing(2 * timeFraction) / 2;
      } else {
        return (2 - timing(2 * (1 - timeFraction))) / 2;
      }
    };
  }

  function quad(progress) {
    return Math.pow(progress, 2);
  }
};
"use strict";

var customersParent = document.querySelector(".customers_text");
var userpicParent = document.querySelector(".customers_userpic");
var flktyUserpic = new Flickity(userpicParent, {
  initialIndex: 1,
  pageDots: false,
  cellSelector: ".customers_userpic-item",
  percentPosition: false,
  arrowShape: {
    x0: 0,
    x1: 40,
    y1: 50,
    x2: 40,
    y2: 45,
    x3: 5
  }
});
var flktyText = new Flickity(customersParent, {
  asNavFor: userpicParent,
  prevNextButtons: false,
  pageDots: false,
  draggable: false
});
"use strict";

var numbered = new Numbered("#consultation_tel", {
  placeholder: true
});
"use strict";

var header = document.querySelector("header.header");
var button = document.querySelector(".first-screen_arrow");
var block = document.querySelector(button.getAttribute("href"));

var handleClick = function handleClick(e) {
  e.preventDefault();
  var currentScroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  var top = document.documentElement.clientTop - currentScroll + header.getBoundingClientRect().height;
  var offset = block.getBoundingClientRect().top - top;

  window._animate(function (progress) {
    window.scrollTo(0, currentScroll * (1 - progress) + progress * offset);
  });
};

button.addEventListener("click", handleClick);
button.addEventListener("touchend", handleClick);
"use strict";

var id = document.getElementById("lightgallery");
lightGallery(id, {
  selector: ".our-works_item "
});
"use strict";

var buttons = document.querySelectorAll(".services_item-more");
var titleArr = document.querySelectorAll(".services_item-title");
var textArr = document.querySelectorAll(".services_item-text");
var popup = document.querySelector(".services_popup");
var closeButton = popup.querySelector("button");
var popupTitle = popup.querySelector(".services_popup-title");
var popupText = popup.querySelector(".services_popup-text");

var _loop = function _loop(i) {
  buttons[i].addEventListener("click", function (e) {
    popupTitle.innerText = titleArr[i].innerText;
    popupText.innerText = textArr[i].innerText;
    popup.classList.add("active");
    document.querySelector("html").classList.add("active");
  });
};

for (var i = 0; i < buttons.length; i++) {
  _loop(i);
}

var closeModal = function closeModal(e) {
  e.stopPropagation();
  e.preventDefault();

  if (e.target === closeButton || e.target === popup) {
    popup.classList.remove("active");
    document.querySelector("html").classList.remove("active");
  }
};

popup.addEventListener("click", closeModal);
"use strict";

var countItemsBlock = document.querySelector("section.statistic");
var countItems = countItemsBlock.querySelectorAll(".statistic_item-count");
var counts = [];

for (var i = 0; i < countItems.length; i++) {
  counts.push(countItems[i].innerText);
  countItems[i].innerText = "0";
}

var animateCounts = function animateCounts() {
  var itemBlockRect = countItemsBlock.getBoundingClientRect();

  if (itemBlockRect.bottom <= window.screen.height + itemBlockRect.height * .5 && itemBlockRect.bottom >= itemBlockRect.height * .5) {
    window.removeEventListener("scroll", animateCounts);

    window._animate(function (progress) {
      for (var _i = 0; _i < countItems.length; _i++) {
        countItems[_i].innerText = parseInt(progress * counts[_i]);
      }
    });
  }
};

window.addEventListener("scroll", animateCounts);
"use strict";

window.addEventListener("load", function (e) {
  ymaps.ready(init);

  function init() {
    // Создание экземпляра карты и его привязка к созданному контейнеру.
    var myMap = new ymaps.Map("footer_yandex-map", {
      center: [52.789066, 41.351899],
      zoom: 11,
      behaviors: ['default', 'scrollZoom'],
      controls: ['searchControl']
    }); // Создание пользовательского балуна

    var MyBalloonLayout = ymaps.templateLayoutFactory.createClass('<div class="footer_map">' + '<div class="footer_map-title">' + 'ДоброДом | Строительство домов на УШП УФФ Тамбов' + '</div>' + '<div class="footer_map-contacts">' + 'Город Тамбов <br>' + 'Телефон: 64-00-45 <br>' + 'E-mail: <a href="mailto:dobrodom68@gmail.com">dobrodom68@gmail.com</a>' + '</div>' + '</div>', {
      build: function build() {
        this.constructor.superclass.build.call(this);
        this.element = this.getParentElement(document.querySelector('.footer_map'));
        this.applyElementOffset();
      },
      onSublayoutSizeChange: function onSublayoutSizeChange() {
        MyBalloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);
        this.applyElementOffset();
        this.events.fire('shapechange');
      },
      applyElementOffset: function applyElementOffset() {
        this.element.querySelector(".footer_map").style.top = -this.element.querySelector(".footer_map").offsetHeight - 20 + "px";
      },
      getShape: function getShape() {
        var position = {
          left: this.element.offsetLeft,
          top: this.element.offsetTop
        };
        return new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([[position.left, position.top], [position.left, position.top - 500]]));
      }
    }); // Создание метки с пользовательским макетом балуна.

    var myPlacemark = window.myPlacemark = new ymaps.Placemark([52.779979, 41.378292], {}, {
      balloonShadow: false,
      balloonLayout: MyBalloonLayout,
      hideIconOnBalloonOpen: true
    }); // Добавление placeholder в поисковую строку

    var searchControl = myMap.controls.get('searchControl');
    searchControl.options.set('placeholderContent', 'Тамбов, Мичуринская улица, 277'); // Получение местоположения, автоматическое отображение его на карте и добавление маршрута.

    var location = ymaps.geolocation;
    location.get({
      mapStateAutoApply: false,
      provider: "browser"
    }).then(function (result) {
      var userAddress = result.geoObjects.get(0).properties.get('text');
      result.geoObjects.get(0).properties.set({
        balloonContentBody: ""
      });
      myMap.geoObjects.add(result.geoObjects);
      myMap.controls.remove('searchControl');
      myMap.controls.add('routePanelControl');
      var control = myMap.controls.get('routePanelControl');
      control.routePanel.state.set({
        from: userAddress,
        to: 'Тамбов, Мичуринская улица, 277'
      }); //Задание пользовательского цвета маршрута

      var multiRoutePromise = control.routePanel.getRouteAsync();
      multiRoutePromise.then(function (multiRoute) {
        multiRoute.options.set({
          routeActiveStrokeColor: "2b2a29",
          routeActiveStrokeWidth: 8
        });
      }, function (err) {
        console.log(err);
      });
    }, function (err) {
      console.log('Ошибка: ' + err);
    });
    myMap.geoObjects.add(myPlacemark);
    myPlacemark.balloon.open();
  }

  ;
});
"use strict";

var header = document.querySelector("header.header");
var buttons = document.querySelectorAll("header a");
var menuButton = document.querySelector(".header_menu-button");
var menuIcon = document.querySelector(".header_menu-icon");
var nav = document.querySelector("nav");

var toggleActive = function toggleActive() {
  nav.classList.toggle("active");
  menuIcon.classList.toggle("active");
};

var handleClick = function handleClick(e) {
  e.preventDefault();
  var block = document.querySelector(e.target.getAttribute("href"));
  var currentScroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  var top = document.documentElement.clientTop - currentScroll + header.getBoundingClientRect().height;
  var offset = block.getBoundingClientRect().top - top;

  window._animate(function (progress) {
    window.scrollTo(0, currentScroll * (1 - progress) + progress * offset);
  });
};

var changeHeaderBackground = function changeHeaderBackground() {
  if (scrollY > 0) {
    header.style.backgroundColor = "#2b2a29";
  } else {
    header.style.backgroundColor = "transparent";
  }
};

changeHeaderBackground();

for (var i = 0; i < buttons.length; i++) {
  buttons[i].addEventListener("click", handleClick, false);
  buttons[i].addEventListener("click", toggleActive, false);
}

menuButton.addEventListener("click", toggleActive, false);
window.addEventListener("scroll", changeHeaderBackground, false);})